<template>
    <div class="settlement-bar">
        <div class="select-btn" @click="event_selectAll">
            <i class="iconfont icon-weixuanze" :class="{'icon-xuanzhong': isAllChecked}"></i>
            <span class="select-text">全选</span>
        </div>
        <div v-show="!isEdit" class="setllement-info" :class="{'vertical-center': cartData.tax === 0}">
            <p class="settlement-price">
                <span class="integer">￥{{totalPrice.split('.')[0] || 0}}</span><span class="decimal">.{{totalPrice.split('.')[1] || 0}}</span>
            </p>
            <p class="price-info">
                <span class="tax" v-show="cartData.tax > 0" @click="event_changeTaxMaskStatus">
                    不含税金
                    <i class="iconfont icon-shuoming"></i>
                </span>
                <span class="discount" v-show="cartData.totalMinusAmount > 0">
                    已优惠￥{{totalMinusAmount}}
                </span>
            </p>
        </div>
        <div v-show="!isEdit" class="settlement-btn" :class="{disabled: cartData.checkedCommonTotalCount === 0}" @click="event_settle">
            去结算<span class="total-num" v-show="cartData.checkedCommonTotalCount > 0">({{cartData.checkedCommonTotalCount}})</span>
        </div>
        <div
            v-show="isEdit"
            class="delete-btn"
            :class="{disabled: !hasCheckedProduct}"
            @click="event_deleteProducts">删除</div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';

    import {api_changeSelectStatus, api_deleteProduct} from '@/api';

    import {handleResCartData} from '@/public/js/public.js';

    const SEC = require('common/js/utils/core.js');

    export default {
        name: '',
        computed: {
            ...mapGetters(['cartData', 'validCartList', 'isTaxMaskShow', 'isEdit', 'upk']),
            // 加工后的总价
            totalPrice () {
                const {realTotalPrice} = this.cartData;
                return realTotalPrice ? SEC.number.currency(realTotalPrice, 2) : '0.00';
            },
            // 是否全选
            isAllChecked () {
                const {validCartList} = this;
                return validCartList.every(item => {
                   return item.isChecked === 1;
                });
            },
            // 是否有选中的商品
            hasCheckedProduct () {
                const {validCartList} = this;
                return validCartList.some(item => {
                    return item.isChecked === 1;
                });
            },
            // 总的优惠金额
            totalMinusAmount () {
                return SEC.number.currency(this.cartData.totalMinusAmount, 2);
            }
        },
        methods: {
            ...mapMutations({
                set_tax_mask_hide: 'SET_TAX_MASK_HIDE',
                set_tax_mask_show: 'SET_TAX_MASK_SHOW'
            }),
            // 全选
            event_selectAll () {
                const _this = this;
                let choseProductInfo = [];
                let isChecked = _this.isAllChecked ? 0 : 1; // 要修改成的状态（1-全选中状态0-非全选中状态）
                let isChose = _this.isAllChecked ? 1 : 0; // 当前是否是选中状态(1-选中状态,0-未选中状态)
                _this.validCartList.forEach(item => {
                    if (item.isChecked === isChose) {
                        const {areaType, packageId, productId, quantity, type} = item;
                        choseProductInfo.push({
                            areaType,
                            packageId,
                            productId,
                            quantity,
                            type
                        });
                    }
                });
                choseProductInfo = JSON.stringify(choseProductInfo);

                api_changeSelectStatus(choseProductInfo, isChecked).then(({data}) => {
                    const {retCode, cart} = data;
                    if (retCode === 0) {
                        handleResCartData(cart);
                    }
                });
            },
            // 设置税金遮罩的显示与隐藏
            event_changeTaxMaskStatus () {
                const _this = this;
                _this.isTaxMaskShow ? _this.set_tax_mask_hide() : _this.set_tax_mask_show();
            },
            // 去结算
            event_settle () {
                if (!this.hasCheckedProduct) {
                    return;
                }
                if (!this.upk) {
                    const href = encodeURIComponent(window.location.href);
                    // 没有upk，直接跳转到登录页
                    window.location.href = `//m.secoo.com/v1/login/?redirect_uri=${href}`;
                } else {
                    window.location.href = '//m.secoo.com/v1/settle/';
                }
            },
            // 删除商品
            event_deleteProducts () {
                const _this = this;
                if (!_this.hasCheckedProduct) {
                    return;
                }

                let itemKeysArr = [], itemKeys;
                _this.validCartList.forEach(item => {
                    const {isChecked, itemKey} = item;
                    if (isChecked === 1) {
                        itemKeysArr.push(itemKey);
                    }
                });

                itemKeys = itemKeysArr.join(',');
                api_deleteProduct(itemKeys).then(({data}) => {
                    const {retCode, cart} = data;

                    if (retCode === 0) {
                        handleResCartData(cart);
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
.settlement-bar {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    height: toRem(100);
    background-color: #FFF;
    box-shadow: 0 0 toRem(20) 0 rgba(0, 0, 0, 0.16);
    z-index: 11;
    .select-btn {
        text-align: center;
        padding: 0 toRem(23) 0;
        .iconfont {
            display: block;
            margin-top: toRem(9);
            line-height: toRem(48);
            font-size: toRem(34);
        }
        .select-text {
            display: block;
            font-family: PingFangSC-Light;
            font-size: toRem(24);
            line-height: toRem(33);
        }
    }
    .setllement-info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        overflow: hidden;
        flex: 1;
        text-align: right;
        padding-right: toRem(20);
        &.vertical-center {
            justify-content: center;
            .settlement-price {
                margin-top: 0;
            }
        }
        .settlement-price {
            height: toRem(48);
            margin-top: toRem(9);
            font-family: Futura-Medium;
            font-size: toRem(34);
            line-height: toRem(48);
            .decimal {
                font-size: toRem(22);
            }
        }
        .price-info {
            font-family: PingFangSC-Light;
            font-size: toRem(24);
            line-height: toRem(33);
            color: #666;
        }
        .tax {
            .iconfont {
                font-size: toRem(28);
                color: $color-gray;
            }
        }
        .discount {
            margin-left: toRem(19);
        }
    }
    .settlement-btn {
        width: toRem(260);
        height: 100%;
        line-height: toRem(100);
        background-color: $color-black;
        color: $color-white;
        font-size: toRem(30);

        text-align: center;
        &.disabled {
            background-color: $color-gray;
        }
        .total-num {
            font-family: Futura-Medium;
        }
    }
    .delete-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: toRem(260);
        height: 100%;
        background-color: $color-black;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: toRem(30);
        line-height: toRem(42);
        color: #FFFFFF;
        &.disabled {
            background-color: $color-gray;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SettlementBar/index.vue